'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const TruckIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14 16.25H9.5M19.2857 16.25H20.25C20.8023 16.25 21.25 15.8023 21.25 15.25V10.3124C21.25 10.109 21.188 9.9104 21.0722 9.74317L19.2982 7.18079C19.1115 6.91099 18.8042 6.75 18.476 6.75H15.25V15M4.64394 16.25H3.75C3.19772 16.25 2.75 15.8023 2.75 15.25V5.75C2.75 5.19772 3.19772 4.75 3.75 4.75H14.25C14.8023 4.75 15.25 5.19772 15.25 5.75V6.84091M14.25 16.75C14.25 18.1307 15.3693 19.25 16.75 19.25C18.1307 19.25 19.25 18.1307 19.25 16.75C19.25 15.3693 18.1307 14.25 16.75 14.25C15.3693 14.25 14.25 15.3693 14.25 16.75ZM4.75 16.75C4.75 18.1307 5.86929 19.25 7.25 19.25C8.63071 19.25 9.75 18.1307 9.75 16.75C9.75 15.3693 8.63071 14.25 7.25 14.25C5.86929 14.25 4.75 15.3693 4.75 16.75Z",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
);
const VpTruckIcon = forwardRef(TruckIcon);

export { VpTruckIcon as default };
